
export enum AttributeKey {
  ACCESS_KEY = 0,
  ACCOUNT_SID = 1,
  AUTH_TOKEN = 2,
  PHONE_NUMBER = 3,
  TOKEN = 4,
}

export class ConfigAttribute {

  id!: number;
  config_key!: ConfigAttribute;
  attribute_key!: AttributeKey;
  attribute_name!: string;
  attribute_value!: string;
}